export default "__VITE_ASSET__1Ftj0vP2__"